import {jsx as $33K1n$jsx, Fragment as $33K1n$Fragment} from "react/jsx-runtime";
import {PostOfficeAnalyticsContext as $33K1n$PostOfficeAnalyticsContext} from "@atlaskit/analytics-namespaced-context";
import $33K1n$atlaskitfeaturegatejsclient from "@atlaskit/feature-gate-js-client";
import {usePostOfficeRoute as $33K1n$usePostOfficeRoute, usePostOfficeContext as $33K1n$usePostOfficeContext, useStableObject as $33K1n$useStableObject, usePostOfficeEnvironment as $33K1n$usePostOfficeEnvironment, API_PATHNAME_STG_PROD as $33K1n$API_PATHNAME_STG_PROD} from "@atlassian/post-office-context";
import {UFOv1 as $33K1n$UFOv1, UFOv2 as $33K1n$UFOv2} from "@atlassian/post-office-frontend-performance-tracking";
import {useMemo as $33K1n$useMemo, useCallback as $33K1n$useCallback} from "react";


      var $parcel$global = globalThis;
    





const $eea7a5749bd788c5$export$85183a312807388d = 'postOffice';
const $eea7a5749bd788c5$export$f7109619a5e9e0d6 = 'post-office-frontend';


const $b0440880a9c9c0c5$var$defaultFetcher = (url)=>fetch(url, {
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        }
    });
const $b0440880a9c9c0c5$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $b0440880a9c9c0c5$var$defaultFetcher, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context)).toString();
    const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams}`);
    // Response will be handled inside the component
    return fetcher(url);
};




const $344754605a4f013a$export$83d6c58b7ab7ae67 = ()=>{
    const { currentEnv: currentEnv, envConfigs: envConfigs } = (0, $33K1n$usePostOfficeEnvironment)();
    return (0, $33K1n$useMemo)(()=>{
        const baseUrl = envConfigs[currentEnv].api.origin;
        // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
        const path = envConfigs[currentEnv].api.pathname ?? (0, $33K1n$API_PATHNAME_STG_PROD);
        return {
            baseUrl: baseUrl,
            path: path
        };
    }, [
        currentEnv,
        envConfigs
    ]);
};


var $39e6683cb74f2025$exports = {};
$39e6683cb74f2025$exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.1.3\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn && yarn build:published\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassiansox/cross-flow-support\":\"workspace:^\",\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@atlassiansox/cross-flow-support\":\"workspace:^\",\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"react-dom\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");


const $db94784e720e2925$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, children: children })=>{
    const isUFOEnabled = (0, $33K1n$atlaskitfeaturegatejsclient).checkGate('enable_ufo_tracking_in_post_office');
    const postOfficeRoute = (0, $33K1n$usePostOfficeRoute)();
    const context = (0, $33K1n$usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $344754605a4f013a$export$83d6c58b7ab7ae67)();
    const stableContextWithRoute = (0, $33K1n$useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $33K1n$useMemo)(()=>isUFOEnabled ? new (0, $33K1n$UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $33K1n$useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = (0, $33K1n$useMemo)(()=>(0, $b0440880a9c9c0c5$export$c4c39037cc4b06ab)(placementId, context, $parcel$global.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        baseUrl,
        path,
        placementId,
        context
    ]);
    const placementAnalyticsContext = (0, $33K1n$useMemo)(()=>({
            source: (0, $eea7a5749bd788c5$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app',
                postOfficeFrontendVersion: $39e6683cb74f2025$exports.version
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $33K1n$jsx)($db94784e720e2925$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $33K1n$jsx)((0, $33K1n$PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $db94784e720e2925$export$2e2bcd8739ae039 = $db94784e720e2925$var$Placement;
const $db94784e720e2925$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $33K1n$jsx)((0, $33K1n$UFOv2).UFOSegment, {
        name: (0, $33K1n$UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $33K1n$jsx)((0, $33K1n$UFOv2).UFOSegment, {
            name: `${(0, $33K1n$UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $33K1n$jsx)((0, $33K1n$Fragment), {
        children: children
    });
};




export {$db94784e720e2925$export$2e2bcd8739ae039 as Placement};
//# sourceMappingURL=index.js.map
